import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * The canonical type scale (LF-5139, `globals.css` @theme) exposes custom
 * font-size utilities named by px — `text-12px`, `text-12-5px`, `text-72px`.
 * tailwind-merge does not know these, so by default it treats an unknown
 * `text-*` as a COLOUR — which would stop a later `text-sm` from overriding an
 * earlier `text-12px` in `cn(...)`. Register the token shape into the
 * `font-size` class group so conflicts resolve correctly (last one wins).
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: [(value: string) => /^\d+(-\d+)?px$/.test(value)] }]
    }
  }
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(date: Date | string | number): string {
  const d = new Date(date);
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}
